export const surveyEndpointIds = {
    SAVE_DROP_SURVEY: 'SAVE_DROP_SURVEY',
    GET_DROP_SURVEYS: 'GET_DROP_SURVEYS',
    GET_DROP_SURVEY: 'GET_DROP_SURVEY',
    DELETE_DROP_SURVEY: 'DELETE_DROP_SURVEY',
    SUBMIT_SATISFACTION_SURVEY: 'SUBMIT_SATISFACTION_SURVEY',
    TRIGGER_SATISFACTION_SURVEYS: 'TRIGGER_SATISFACTION_SURVEYS',
    IS_SATISFACTION_SURVEY_EMAILED: 'IS_SATISFACTION_SURVEY_EMAILED',
    SATISFACTION_SURVEY_LIFECYCLE: 'SATISFACTION_SURVEY_LIFECYCLE',
    IGNORE_SATISFACTION_SURVEY: 'IGNORE_SATISFACTION_SURVEY',
    GET_SATISFACTION_SURVEY_STATS_DATA: 'GET_SATISFACTION_SURVEY_STATS_DATA',
};
